import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const IMG = {
  // Hero + process — real stock photography
  hero: "https://images.unsplash.com/photo-1551029506-0807df4e2031?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  proc1: "https://images.unsplash.com/photo-1549737221-bef65e2604a6?q=80&w=1000",
  proc2: "https://images.pexels.com/photos/3457273/pexels-photo-3457273.jpeg?auto=compress&cs=tinysrgb&w=1000",
  proc3: "https://images.unsplash.com/photo-1543002588-bfa74002ed7e?q=80&w=1000",
  proc4: "https://images.pexels.com/photos/1741230/pexels-photo-1741230.jpeg?auto=compress&cs=tinysrgb&w=1000",
  proc5: "https://images.unsplash.com/photo-1520467795206-62e33627e6ce?q=80&w=1000",
  animScene: "https://images.unsplash.com/photo-1491841550275-ad7854e35ca6?q=80&w=1400",
  giftPhoto: "https://images.unsplash.com/photo-1513201099705-a9746e1e201f?q=80&w=1200",
  // Story worlds — real stock photography
  worldDino: "https://images.pexels.com/photos/13681288/pexels-photo-13681288.jpeg?auto=compress&cs=tinysrgb&w=900",
  worldSpace: "https://images.unsplash.com/photo-1464802686167-b939a6910659?q=80&w=900",
  worldDragon: "https://images.unsplash.com/photo-1504252060324-1c76e2e09939?q=80&w=900",
  worldKingdom: "https://images.pexels.com/photos/234311/pexels-photo-234311.jpeg?auto=compress&cs=tinysrgb&w=900",
  worldOcean: "https://images.pexels.com/photos/6181119/pexels-photo-6181119.jpeg?auto=compress&cs=tinysrgb&w=900",
  worldAnimals: "https://images.unsplash.com/photo-1520124442480-b5c60b0f80c2?q=80&w=900",
  // Sample book covers — user-provided artwork (kept)
  cover1: "https://customer-assets-v7afamib.emergentagent.net/job_magic-book-lab/artifacts/h7smrdub_IMG_4062.jpeg",
  cover2: "https://customer-assets-v7afamib.emergentagent.net/job_magic-book-lab/artifacts/oeepj8oe_IMG_4071.jpeg",
  cover3: "https://customer-assets-v7afamib.emergentagent.net/job_magic-book-lab/artifacts/vke7p9um_IMG_4072.jpeg",
  cover4: "https://customer-assets-v7afamib.emergentagent.net/job_magic-book-lab/artifacts/dh2xbngu_IMG_4060.webp",
  // Book interior spreads
  spread1: "https://images.unsplash.com/photo-1605627082049-2e77d4d16716?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100",
  spread2: "https://images.unsplash.com/photo-1514467159223-eae20502f859?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100",
  spread3: "https://images.unsplash.com/photo-1674566992405-bba2e05abf9f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100",
  spread4: "https://images.unsplash.com/photo-1623413838753-1ed066a7a67f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100",
  // Quality closeups
  qualGold: "https://images.unsplash.com/photo-1618470341957-dc61f2aa50d1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  qualPages: "https://images.unsplash.com/photo-1556803444-2deaa865482b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  qualBind: "https://images.unsplash.com/photo-1514467159223-eae20502f859?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  // Occasions
  occBirthday: "https://images.unsplash.com/photo-1608790672275-309c02d888ff?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  occXmas: "https://images.unsplash.com/photo-1640101128550-cfb12d3d1f43?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  occBaby: "https://images.unsplash.com/photo-1602863211750-0b05508292b0?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  occGrand: "https://images.unsplash.com/photo-1714646793149-189cc073b387?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
};
